import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { StoreState } from '../../store'
import * as actions from '../../store/modules/cerc/actions'
import { parseDate } from '../../utils/masks'
import { Popover } from '@headlessui/react'
import { FiTrash2 } from 'react-icons/fi'
import { MdCreditScore } from 'react-icons/md'
import { Container, Title, List, IconButton, ListContainer } from './styles'
import { Link } from 'react-router-dom'
import { selectedMenu } from '../../store/modules/menu/actions'
import { calcDiffDays } from '../../utils/date'
import { useCommision } from '../../hooks/commission'
import ModalBackground from '../ModalBackground'
import { BsX } from 'react-icons/bs'
import { useCredenciadoras } from '../../hooks/credenciadoras'

const CartPopover: React.FC = () => {
    const dispatch = useDispatch()
    const { unidadesRecebiveisSelecionadas } = useSelector(
        (state: StoreState) => state.cerc
    )
    const { todasCredenciadoras } = useCredenciadoras()
    const { getPaymentCommission } = useCommision()
    // const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    // const [taxa, setTaxa] = useState(0)
    // const [commissionValues, setCommissionValue] = useState([] as any)
    // const { register, control, handleSubmit, formState: { errors }, getValues } = useForm<Inputs>()
    // const [openOneClick, setOpenOneClick] = useState(false)
    const [selectFavs, setSelectFavs] = useState(false)
    // const [favoritos, setFavoritos] = useState([])
    // const submit: SubmitHandler<Inputs> = (input) => {
    // }

    // const getTaxa = useCallback(async () => {
    //     try {
    //         if(taxa === 0) {
    //             const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
    //             setCommissionValue(data.valoresVariaveis)
    //             // setTaxa(data)
    //         }

    //         // if(selectFavs) {
    //         //     const { data } = await api.get(`/contatos/${cnpj_cpf}`)
    //         //     setFavoritos(data)
    //         // }
    //     } catch (error) {
    //     }
    // }, [cnpj_cpf, taxa])
    // useEffect(() => {
    //     getTaxa()
    // }, [getTaxa])

    // const crendeciadora: keyof typeof todasCredenciadoras =
    //     unidadesRecebiveisSelecionadas[0]
    //         ?.instituicaoCredenciadora as keyof typeof todasCredenciadoras
    // const nomeCredeciadora = todasCredenciadoras[crendeciadora]

    const subtotal = unidadesRecebiveisSelecionadas.reduce((total, atual) => {
        return total + Number(atual.valorLivreSelecionado)
    }, 0)

    let commissonValue = getPaymentCommission(subtotal)

    const total =
        unidadesRecebiveisSelecionadas.length > 0
            ? Number((subtotal + commissonValue).toFixed(2))
            : 0

    const totalDias = unidadesRecebiveisSelecionadas.reduce(
        (total, unidade) => {
            const diffDays = calcDiffDays(unidade.dataLiquidacao)
            return total + diffDays
        },
        0
    )

    const prazoMedio = totalDias / unidadesRecebiveisSelecionadas.length

    return (
        <Popover>
            <Popover.Button>
                <IconButton>
                    <MdCreditScore color="#333" size={24} />
                    <span
                        className={
                            unidadesRecebiveisSelecionadas.length === 0
                                ? 'hidden'
                                : ''
                        }
                    >
                        {unidadesRecebiveisSelecionadas.length}
                    </span>
                </IconButton>
            </Popover.Button>

            <Popover.Panel>
                {({ close }) => (
                    <>
                        <ModalBackground close={close} />
                        <Container>
                            <Title>
                                <div>
                                    <p>Unidades Recebiveis</p>
                                    <span>
                                        {unidadesRecebiveisSelecionadas.length}
                                    </span>
                                </div>
                                <button onClick={() => close()}>
                                    <BsX size={34} color="#333" />
                                </button>
                            </Title>
                            <ListContainer>
                                <List>
                                    {unidadesRecebiveisSelecionadas.length ===
                                        0 && (
                                        <p className="message">
                                            Você ainda não selecionou nenhuma
                                            unidade recebivel
                                        </p>
                                    )}
                                    {unidadesRecebiveisSelecionadas.map(
                                        (unidade) => {
                                            // const dataLiquidacaoParsed = parseDate(unidade.dataLiquidacao)
                                            const diffDays = calcDiffDays(
                                                unidade.dataLiquidacao
                                            )
                                            return (
                                                <li
                                                    className="item"
                                                    key={unidade.id}
                                                >
                                                    <div className="data">
                                                        <p>
                                                            <span>
                                                                Data liquidação:
                                                            </span>{' '}
                                                            {parseDate(
                                                                unidade.dataLiquidacao,
                                                                true
                                                            )}{' '}
                                                            ({diffDays} dias)
                                                        </p>
                                                    </div>
                                                    <p className="total">
                                                        <span>
                                                            Valor selecionado:{' '}
                                                        </span>
                                                        {Number(
                                                            unidade.valorLivreSelecionado
                                                        ).toLocaleString(
                                                            'pt-br',
                                                            {
                                                                style: 'currency',
                                                                currency: 'BRL',
                                                            }
                                                        )}
                                                    </p>
                                                </li>
                                            )
                                        }
                                    )}
                                </List>
                            </ListContainer>

                            <div>
                                <div className="details">
                                    <p>
                                        <span>Subtotal:</span>
                                        {subtotal.toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        })}
                                    </p>
                                    <p>
                                        <span>Taxa: </span>
                                        {commissonValue.toLocaleString(
                                            'pt-br',
                                            {
                                                style: 'currency',
                                                currency: 'BRL',
                                            }
                                        )}
                                    </p>
                                    <p>
                                        <span>Total :</span>
                                        {total.toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        })}
                                    </p>
                                    <p>
                                        <span>Prazo médio de liquidação: </span>
                                        {Math.round(prazoMedio) || 0} dias
                                    </p>
                                    {/* <p><span>Credenciadora:</span> {nomeCredeciadora}</p> */}
                                </div>
                                {/* <button title='Ao selecionar a opção de favoritos, o botão mudará para "Enviar" e o pagamento será enviado no clique do botão (note que você ainda poderá confirmar os dados de pagamento antes do envio).' onClick={() => setOpenOneClick(!openOneClick)} className="click">
                              <h2>Envio com um clique</h2>
                                <MdKeyboardArrowDown size={22}/>
                            </button>
                            {openOneClick && (
                              <OneCLick>
                                <form onSubmit={handleSubmit(submit)} id='my-form'>
                                    <div className="input-wrapper">
                                        <FormControlLabel
                                            control={<Checkbox checked={selectFavs} onChange={(e, newValue) => setSelectFavs(newValue)} />}
                                            label='Enviar para contatos favoritos'
                                        />
                                    </div>
                                    <div className="input-wrapper">
                                        <Controller defaultValue='' name='contatoSelecionado' control={control} rules={{ required: 'Selecione um contato favorito' }} render={({ field }) => (
                                            <Autocomplete
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue)
                                                }}

                                                getOptionLabel={(option: any) => {
                                                    return option.nomeTitular
                                                }}
                                                isOptionEqualToValue={(option, value) => {
                                                    return option === value
                                                }}
                                                disablePortal
                                                disabled={!selectFavs}
                                                id="fav"
                                                options={favoritos}
                                                sx={{ width: '100%', fontFamily: 'Roboto', fontSize: '16px' }}
                                                renderInput={(params) => <TextField {...params} label="" placeholder='Contatos favoritos' />}
                                            />
                                        )} />
                                        {errors.contatoSelecionado && errors.contatoSelecionado.type === 'required' && (<span>*Selecione um contato favorito</span>)}
                                    </div>
                                </form>
                                <div className='help' title='Ao selecionar a opção de favoritos, o botão mudará para "Enviar" e o pagamento será enviado no clique do botão (note que você ainda poderá confirmar os dados de pagamento antes do envio).'>
                                    <span>Ajuda</span> <MdHelpOutline size={17}/>
                                </div>
                                <span className='cadastrar'>Precisa cadastrar um favorito? <Link to='/'>Clique aqui!</Link> </span>
                              </OneCLick>
                            )} */}
                                <div className="actions">
                                    <span
                                        onClick={() =>
                                            dispatch(actions.cercDeleteAllURs())
                                        }
                                    >
                                        Apagar tudo <FiTrash2 />
                                    </span>
                                    {/* <Popover.Button> */}
                                    {selectFavs ? (
                                        <button className="button">
                                            Pagar
                                        </button>
                                    ) : (
                                        <Link
                                            to="/pagar"
                                            className="button"
                                            onClick={(e) => {
                                                dispatch(
                                                    selectedMenu({
                                                        mainMenu: 'Pagar',
                                                        subMenu: '',
                                                        currentLink: '/pagar',
                                                    })
                                                )
                                                return close()
                                            }}
                                        >
                                            Gerar contrato
                                        </Link>
                                    )}

                                    {/* </Popover.Button> */}
                                </div>
                            </div>
                        </Container>
                    </>
                )}
            </Popover.Panel>
        </Popover>
    )
}

export default CartPopover
